import { ConcreteEncodable } from "./ConcreteEncodable";

import { AlgoStrategyImplEncoder } from "../../encoder/AlgoStrategyImplEncoder";

import * as CubiqTS from "../../index";
import { AlgoStrategy } from "../AlgoStrategy";

export class AlgoStrategyImpl extends ConcreteEncodable implements AlgoStrategy {
  public static enType: string = "com.bcdfx.model.AlgoStrategyImpl";

  /*FID=1*/
  public id: string;
  /*FID=2*/
  public description: string;
  /*FID=3*/
  public adtlDefinition: string;
  /*FID=4*/
  public emailAggThreshold: CubiqTS.Long | null = null;
  /*FID=5*/
  public isStpAggregation: boolean;
  /*FID=6*/
  public behaviouralOrderTypeId: CubiqTS.OrderType;
  /*FID=7*/
  public isRouteUnsolicitedCancelToAltTg: boolean;
  /*FID=8*/
  public algoLimitPrice: CubiqTS.AlgoLimitPrice;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AlgoStrategyImplEncoder.Instance;
    this.setEncodableType(AlgoStrategyImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AlgoStrategyImpl[" +
      "id=" +
      this.id +
      "description=" +
      this.description +
      "adtlDefinition=" +
      this.adtlDefinition +
      "emailAggThreshold=" +
      this.emailAggThreshold +
      "isStpAggregation=" +
      this.isStpAggregation +
      "behaviouralOrderTypeId=" +
      this.behaviouralOrderTypeId +
      "isRouteUnsolicitedCancelToAltTg=" +
      this.isRouteUnsolicitedCancelToAltTg +
      "algoLimitPrice=" +
      this.algoLimitPrice +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
